import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, mergeProps as _mergeProps, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "v-card-title px-0 mx-0"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "d-inline-flex" }
const _hoisted_4 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_5 = {
  key: 0,
  class: "text-subtitle-1"
}
const _hoisted_6 = {
  key: 1,
  class: "text-subtitle-1"
}
const _hoisted_7 = {
  key: 2,
  class: "text-subtitle-1"
}
const _hoisted_8 = {
  key: 3,
  class: "text-subtitle-1"
}
const _hoisted_9 = { class: "d-flex my-4" }
const _hoisted_10 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "d-flex justify-center pa-6" }, {
    default: _withCtx(() => [
      (_ctx.pending)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "d-flex justify-center align-center",
            height: "400px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                "model-value": "20",
                size: "100",
                color: "primary",
                indeterminate: ""
              })
            ]),
            _: 1
          }))
        : (_ctx.calendarData)
          ? (_openBlock(), _createBlock(_component_v_sheet, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window, {
                  modelValue: _ctx.step,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.step) = $event)),
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, {
                      value: 1,
                      disabled: "",
                      width: "320px",
                      class: "justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: "logo.jpg",
                          class: "pl-16",
                          width: "300px"
                        }),
                        (_ctx.promo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.promoTitle), 1))
                          : _createCommentVNode("", true),
                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-body-1 text-grey-darken-1 px-0 mx-0 pb-1" }, "Выберите количество билетов:", -1)),
                        (_ctx.dayTickets && _ctx.dayTickets.prices)
                          ? (_openBlock(), _createBlock(_component_v_card, {
                              key: 1,
                              "max-width": "320px",
                              elevation: "0",
                              class: "d-flex justify-center px-0 mx-0"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayTickets.prices, (ticket) => {
                                  return (_openBlock(), _createBlock(_component_v_card, {
                                    key: ticket.ticket_date,
                                    class: "mb-3",
                                    variant: "outlined"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_title, { class: "text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(ticket.exposition_name), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(ticket.exposition_description) + " " + _toDisplayString(ticket.ticket_type_name), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.formatMoney(ticket.price)) + ", билетов:", 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _withDirectives(_createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: "tonal",
                                            icon: "mdi-minus",
                                            class: "ma-1",
                                            onClick: ($event: any) => (_ctx.addTicket(ticket, -1))
                                          }, null, 8, ["onClick"]), [
                                            [_vShow, _ctx.getSelectedTicketCount(ticket)]
                                          ]),
                                          _withDirectives(_createElementVNode("div", { class: "text-h6" }, _toDisplayString(_ctx.getSelectedTicketCount(ticket)), 513), [
                                            [_vShow, _ctx.getSelectedTicketCount(ticket)]
                                          ]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: "tonal",
                                            icon: "mdi-plus",
                                            class: "ma-1",
                                            onClick: ($event: any) => (_ctx.addTicket(ticket, 1))
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.getSelectedCount()>0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createVNode(_component_v_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Итого " + _toDisplayString(_ctx.formatMoney(_ctx.getSelectedSum())) + " билетов: " + _toDisplayString(_ctx.getSelectedCount()), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                type: "submit",
                                class: "font-weight-bold",
                                variant: "flat",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step=2))
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode("Далее ")
                                ])),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, {
                      value: 2,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                            _createTextVNode("Ваши данные "),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode("для получения билетов")
                          ])),
                          _: 1
                        }),
                        _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                        _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_sheet, {
                          width: "320px",
                          class: "v-container justify-center align-center align-self-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, {
                              onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                              ref: "clientForm",
                              class: "pa-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.client.name,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.client.name) = $event)),
                                  rules: _ctx.nameRules,
                                  label: "Имя",
                                  name: "name",
                                  type: "text",
                                  variant: "underlined"
                                }, null, 8, ["modelValue", "rules"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.client.email,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.client.email) = $event)),
                                  rules: _ctx.emailRules,
                                  label: `E-mail для получения билетов`,
                                  type: "email",
                                  name: "email",
                                  variant: "underlined"
                                }, null, 8, ["modelValue", "rules"]),
                                (_ctx.showTel)
                                  ? (_openBlock(), _createBlock(_component_v_text_field, {
                                      key: 0,
                                      modelValue: _ctx.client.tel,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.client.tel) = $event)),
                                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.client.tel = _ctx.client.tel.replace('+7',''))),
                                      rules: _ctx.telRules,
                                      prefix: "+7",
                                      label: "Телефон",
                                      type: "tel",
                                      name: "tel",
                                      variant: "underlined"
                                    }, null, 8, ["modelValue", "rules"]))
                                  : _createCommentVNode("", true),
                                (0)
                                  ? (_openBlock(), _createBlock(_component_v_text_field, {
                                      key: 1,
                                      _type: "date",
                                      modelValue: _ctx.client.birthDate,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.client.birthDate) = $event)),
                                      rules: _ctx.dateRules,
                                      onInput: _ctx.onInputBirthDate,
                                      label: "Дата рождения",
                                      variant: "underlined",
                                      required: ""
                                    }, null, 8, ["modelValue", "rules", "onInput"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 512),
                            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                            _createVNode(_component_v_container, { class: "d-flex justify-space-between" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.step=1)),
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                                    _createTextVNode(" Назад ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  _disabled: "client.error",
                                  type: "submit",
                                  class: "font-weight-bold",
                                  variant: "flat",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSubmitClientForm()))
                                }, {
                                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                                    _createTextVNode(" Далее ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                            _createVNode(_component_v_card_subtitle, { class: "text-wrap justify-end" }, {
                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                _createTextVNode(" Нажимая «Далее», вы соглашаетесь с "),
                                _createElementVNode("a", {
                                  href: "https://tickets.crocus-oceanarium.ru/offer",
                                  target: "_blank",
                                  style: {"color":"black"}
                                }, " Условиями приобретения и Офертой", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, {
                      value: 3,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_sheet, {
                            width: "320px",
                            class: "d-flex flex-column align-center"
                          }, {
                            default: _withCtx(() => [
                              _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
                              _createVNode(_component_v_card_title, { class: "pt-0 pb-0" }, {
                                default: _withCtx(() => _cache[34] || (_cache[34] = [
                                  _createTextVNode("Подтверждение заказа")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_container, { class: "d-flex flex-column justify-space-between" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, { class: "d-flex flex-column justify-start pt-2 pb-0 text-left" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_4, _toDisplayString(this.toUserDate(_ctx.date)), 1),
                                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text-caption" }, "Крокус Сити Океанариум", -1)),
                                      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-caption" }, [
                                        _createTextVNode("66-й км МКАД, Крокус Сити"),
                                        _createElementVNode("br"),
                                        _createTextVNode("станция метро Мякинино (последний вагон из центра) ")
                                      ], -1)),
                                      _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                                      (_ctx.client.name)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.client.name), 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.client.birthDate)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Дата рождения: " + _toDisplayString(_ctx.client.birthDate), 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.client.tel)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.client.tel), 1))
                                        : _createCommentVNode("", true),
                                      (_ctx.client.email)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.client.email), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expansion_panels, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel, { class: "elevation-0" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panel_title, { class: "text-body-1 font-weight-bold text-left" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Билетов: " + _toDisplayString(_ctx.getTotalCount()), 1)
                                            ]),
                                            _: 1
                                          }),
                                          (_ctx.selectedTickets)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedTickets, (ticket, i) => {
                                                return (_openBlock(), _createBlock(_component_v_expansion_panel_text, {
                                                  key: i,
                                                  class: "text-body-2 text-left"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(ticket.exposition_name) + " " + _toDisplayString(ticket.ticket_type_name) + " x" + _toDisplayString(ticket.count) + " " + _toDisplayString(_ctx.formatMoney(Math.round(ticket.price * ticket.count))), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_text, { class: "text-body-1 font-weight-bold text-no-wrap text-left pt-2 pb-0 mr-0 pr-0" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString('Итоговая стоимость:') + " " + _toDisplayString(_ctx.formatMoney(_ctx.getSelectedSum())), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_dialog, {
                                    modelValue: _ctx.dialogPromo,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogPromo) = $event)),
                                    width: "auto"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      (0)
                                        ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                                            class: "my-2",
                                            color: "primary",
                                            variant: "tonal"
                                          }), {
                                            default: _withCtx(() => _cache[38] || (_cache[38] = [
                                              _createTextVNode(" Ввести промокод % ")
                                            ])),
                                            _: 2
                                          }, 1040))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        "max-width": "400",
                                        "min-width": "320",
                                        loading: _ctx.dialogPromoPending ? _ctx.primaryColor : false,
                                        disabled: _ctx.dialogPromoPending
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            focused: "",
                                            clearable: "",
                                            autofocus: "",
                                            modelValue: _ctx.promoCode,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.promoCode) = $event)),
                                            "error-messages": _ctx.promoCodeError,
                                            label: "Промокод",
                                            variant: "outlined",
                                            class: "pa-4 pb-0 font-weight-bold",
                                            onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.promoCode = _ctx.promoCode.toUpperCase())),
                                            color: "primary"
                                          }, null, 8, ["modelValue", "error-messages"]),
                                          _createVNode(_component_v_card_actions, { class: "justify-center my-2 mx-2" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.dialogPromo = false; _ctx.promoCode = ''; _ctx.promoCodeError = ''}),
                                                variant: "tonal"
                                              }, {
                                                default: _withCtx(() => _cache[39] || (_cache[39] = [
                                                  _createTextVNode("Отмена ")
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_spacer),
                                              _createVNode(_component_v_btn, {
                                                color: "primary",
                                                class: "font-weight-bold",
                                                onClick: _ctx.applyPromoCode,
                                                variant: "flat"
                                              }, {
                                                default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                  _createTextVNode(" Применить ")
                                                ])),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["loading", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      checked: _ctx.conditionsAgree,
                                      class: _normalizeClass({'text-red': _ctx.conditionsAlarm && !_ctx.conditionsAgree}),
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.conditionsAgree) = $event))
                                    }, null, 10, _hoisted_10), [
                                      [_vModelCheckbox, _ctx.conditionsAgree]
                                    ]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["text-wrap pl-2 ma-0 text-body-1 text-left", {'text-red': _ctx.conditionsAlarm && !_ctx.conditionsAgree}])
                                    }, " Согласен с Условиями приобретения и Офертой ", 2)
                                  ]),
                                  _createVNode(_component_v_btn, {
                                    color: "primary",
                                    class: "mt-0 mb-2 font-weight-bold",
                                    variant: "flat",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.createOrder(false)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getTotalSum() > 0 ? 'Перейти к оплате' : 'Оформить Заказ'), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (1)
                                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                                        key: 0,
                                        modelValue: _ctx.dialogSellerInfo,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dialogSellerInfo) = $event)),
                                        width: "auto"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_card_subtitle, _mergeProps(props, { style: {"cursor":"pointer"} }), {
                                            default: _withCtx(() => _cache[41] || (_cache[41] = [
                                              _createTextVNode(" Информация о продавце ")
                                            ])),
                                            _: 2
                                          }, 1040)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, { "max-width": "340" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.legalInfo), 1)
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn, {
                                                    variant: "tonal",
                                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogSellerInfo = false))
                                                  }, {
                                                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                      _createTextVNode("Закрыть")
                                                    ])),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.step=2)),
                                    class: "my-3",
                                    variant: "tonal"
                                  }, {
                                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                                      _createTextVNode("Назад")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, {
                      value: 4,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => _cache[45] || (_cache[45] = [
                            _createTextVNode("Резервирование...")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_sheet, {
                          width: "320px",
                          class: "d-inline-flex flex-column justify-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_progress_circular, {
                                  class: "mt-12",
                                  "model-value": "20",
                                  size: "100",
                                  color: "primary",
                                  indeterminate: ""
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, {
                      value: 5,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        (_ctx.orderData)
                          ? (_openBlock(), _createBlock(_component_v_sheet, {
                              key: 0,
                              width: "320px",
                              class: "d-inline-flex flex-column justify-start"
                            }, {
                              default: _withCtx(() => [
                                _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
                                _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1)),
                                _createVNode(_component_v_card_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Заказ " + _toDisplayString(_ctx.orderData.pay_order_id), 1),
                                    _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                                    _cache[48] || (_cache[48] = _createTextVNode("успешно зарезервирован."))
                                  ]),
                                  _: 1
                                }),
                                _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1)),
                                (0)
                                  ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                      default: _withCtx(() => _cache[49] || (_cache[49] = [
                                        _createTextVNode(" Пожалуйста завершите оплату заказа на странице платежной системы. ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.orderData.paySeconds)
                                  ? (_openBlock(), _createBlock(_component_v_card_title, {
                                      key: 1,
                                      color: _ctx.orderData.paySeconds < 30 ? 'red' : ''
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Время резерва " + _toDisplayString(_ctx.formatTimer(_ctx.orderData.paySeconds)), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color"]))
                                  : _createCommentVNode("", true),
                                _cache[55] || (_cache[55] = _createElementVNode("br", null, null, -1)),
                                _createVNode(_component_v_btn, {
                                  href: _ctx.orderData.pay_url,
                                  target: "_blank",
                                  class: "my-0 font-weight-bold",
                                  color: "primary",
                                  variant: "flat"
                                }, {
                                  default: _withCtx(() => _cache[50] || (_cache[50] = [
                                    _createTextVNode(" Перейти к оплате ")
                                  ])),
                                  _: 1
                                }, 8, ["href"]),
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => _cache[51] || (_cache[51] = [
                                    _createTextVNode(" Вы будете перенаправлены на страницу платежной системы: ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, {
                      value: 6,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
                        _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
                        _cache[62] || (_cache[62] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_icon, {
                          class: "mb-5",
                          color: "success",
                          icon: "mdi-check-circle",
                          size: "112"
                        }),
                        _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => _cache[56] || (_cache[56] = [
                            _createTextVNode("Успешная покупка!")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_sheet, {
                          width: "320px",
                          class: "d-inline-flex flex-column justify-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Ваши " + _toDisplayString(_ctx.eventData.ticketNameMany.toLowerCase()) + " отправлены на почту " + _toDisplayString(_ctx.client.email), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_btn, { onClick: _ctx.close }, {
                                  default: _withCtx(() => _cache[57] || (_cache[57] = [
                                    _createTextVNode(" Вернуться ")
                                  ])),
                                  _: 1
                                }, 8, ["onClick"]),
                                _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1)),
                                _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, {
                      value: 7,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
                        _cache[70] || (_cache[70] = _createElementVNode("br", null, null, -1)),
                        _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_icon, {
                          class: "mb-5",
                          color: "amber-lighten-3",
                          icon: "mdi-close-circle-outline",
                          size: "112"
                        }),
                        _cache[72] || (_cache[72] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => _cache[64] || (_cache[64] = [
                            _createTextVNode("Что-то пошло не так")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_sheet, {
                          width: "320px",
                          class: "d-inline-flex flex-column justify-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.errorText), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_btn, { onClick: _ctx.close }, {
                                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                                    _createTextVNode(" Вернуться ")
                                  ])),
                                  _: 1
                                }, 8, ["onClick"]),
                                _cache[66] || (_cache[66] = _createElementVNode("br", null, null, -1)),
                                _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
                                _cache[68] || (_cache[68] = _createElementVNode("br", null, null, -1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_dialog, {
                  modelValue: _ctx.closeDialog,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.closeDialog) = $event)),
                  width: "auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      "max-width": "340",
                      class: "pt-2 px-6 pb-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "ma-2" }, {
                          default: _withCtx(() => _cache[73] || (_cache[73] = [
                            _createTextVNode("Вы точно хотите выйти?")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "flat",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.closeDialog=false)),
                          class: "font-weight-bold"
                        }, {
                          default: _withCtx(() => _cache[74] || (_cache[74] = [
                            _createTextVNode("Продолжить покупку ")
                          ])),
                          _: 1
                        }),
                        _cache[76] || (_cache[76] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.close,
                          variant: "tonal"
                        }, {
                          default: _withCtx(() => _cache[75] || (_cache[75] = [
                            _createTextVNode("Выйти")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_sheet, {
              key: 2,
              class: "ma-16",
              height: "400px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "mx-10" }, {
                  default: _withCtx(() => _cache[77] || (_cache[77] = [
                    _createTextVNode("Сервис временно недоступен"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode("Попробуйте позже")
                  ])),
                  _: 1
                }),
                _cache[79] || (_cache[79] = _createElementVNode("br", null, null, -1)),
                _cache[80] || (_cache[80] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  class: "font-weight-bold",
                  onClick: _ctx.reloadPage
                }, {
                  default: _withCtx(() => _cache[78] || (_cache[78] = [
                    _createTextVNode(" Попробовать снова ")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
    ]),
    _: 1
  }))
}